<a mat-list-item [routerLink]="" (click)="doGetReport()">
    <ng-container *ngIf="!loading"><mat-icon matListIcon>cloud_download</mat-icon> Generate report</ng-container>
    <ng-container *ngIf="loading"><mat-spinner [diameter]="25"></mat-spinner> Downloading report</ng-container>
</a>
